export default {
  'component.infoseller.agent': 'Megler',
  'component.infoseller.agent.name': 'Megler',
  'component.infoseller.agent.subagent1': 'Underagent 1',
  'component.infoseller.agent.subagent2': 'Underagent 2',
  'component.infoseller.title': 'Info fra selger',
  'component.stylist.placeholder':
    'Søk etter oppdrag nr., selgernavn, e-post, telefon, eiendomsadresse og stylingtype',
};
